import type * as React from 'react'
import { cn } from '@/lib/utils'

/* ────────────────────────── Types ────────────────────────────────── */

interface DetailFieldProps {
	/** Label text displayed above the value */
	label: string
	/** Value to display */
	value: React.ReactNode
	/** Optional className for the container */
	className?: string
}

/* ────────────────────────── Component ───────────────────────────── */

/**
 * Consistent label-value display component used in detail views.
 * Displays a muted label above a value. Designed to work within
 * InspectionDetailsSection for automatic layout and spacing.
 */
export function DetailField({ label, value, className }: DetailFieldProps) {
	return (
		<div className={cn('flex-1 min-w-[180px]', className)}>
			<h3 className="text-xs font-semibold text-kaefer-dark-grey mb-2">
				{label}
			</h3>
			<p className="text-sm text-kaefer-dark-grey leading-relaxed break-words">
				{value}
			</p>
		</div>
	)
}
